// https://api.egtogo.com/website/send-enquiry-email
import axios from "axios";
export const sendEnquiryApi = async (data) => {
    try {
        const response = await axios.post('https://api.egtogo.com/website/send-enquiry-email', data);
        return response;
    } catch (error) {
        console.error("Error sending enquiry:", error);
        throw error; // Rethrow the error after logging it
    }
}